/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_AcreageInputs */

const vi_grower_area_public_acreage = /** @type {(inputs: Grower_Area_Public_AcreageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diện tích`)
};

/**

* @param {Grower_Area_Public_AcreageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_acreage = /** @type {((inputs?: Grower_Area_Public_AcreageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_AcreageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_acreage(inputs)
});